import './AttachFileChatPost.css';
import Utils from '@/common/utils/utils';
import { PropTypes } from 'prop-types';
import { useMemo } from 'react';
import ImageAttachFile from './ImageAttachFile';
import OtherAttachFile from './OtherAttachFile';
import { getChatPostAttachFiles, separateImageAndOtherFiles } from './AttachFileHandler';
import trI18n from '@/common/utils/trI18n';
import useTranslationSubscription from '@/hooks/useTranslation';

function AttachFileChatPost ({
    detailTicket,
    setOpenPreviewImage,
    setOpenFileOption,
    setOpenOption
}) {
    useTranslationSubscription();
    
    const chatPostAttachFileList = useMemo(
        () => getChatPostAttachFiles(detailTicket?.attachFiles),
        [detailTicket?.attachFiles]
    );
    
    const { images: imgAttachFileList, others: otherAttachFileList } = useMemo(
        () => separateImageAndOtherFiles(chatPostAttachFileList),
        [chatPostAttachFileList]
    );

    // Don't render if there's no data
    if (Utils.isEmptyArray(imgAttachFileList) && Utils.isEmptyArray(otherAttachFileList)) {
        return null;
    }

    return (
        <div className="attach-file-chat-post-container">
            <p className="attach-file-chat-post-title">
                {trI18n('IMG_CHATPOST_FIELD')}
            </p>
            {!Utils.isEmptyArray(otherAttachFileList) && (
                <ul className="attach-file-chat-post-list">
                    {
                        otherAttachFileList.map(item => (
                            <li key={item.id} className="attach-file-chat-post-item">
                                <OtherAttachFile
                                    attachData={item}
                                    detailTicket={detailTicket}
                                    setOpenFileOption={setOpenFileOption}
                                    setOpenOption={setOpenOption}
                                />
                            </li>
                        ))
                    }
                </ul>
            )}
            <div className="attach-file-chat-post-images">
                {imgAttachFileList.map(item => (
                    <ImageAttachFile
                        key={item.id || item.originId}
                        attachData={item}
                        detailTicket={detailTicket}
                        setOpenPreviewImage={setOpenPreviewImage}
                        setOpenFileOption={setOpenFileOption}
                        setOpenOption={setOpenOption}
                    />
                ))}
            </div>
        </div>
    );
};

AttachFileChatPost.propTypes = {
    detailTicket: PropTypes.any,
    setOpenPreviewImage: PropTypes.any,
    setOpenFileOption: PropTypes.any,
    setOpenOption: PropTypes.any
};

export default AttachFileChatPost;
